import { MAN_SET_MANIFESTOS_SUCCESS } from '../actions/types';

const INITIAL_STATE = {
  manifestos: [],
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case MAN_SET_MANIFESTOS_SUCCESS:
      return { ...state, manifestos: payload };
    default:
      return state;
  }
};
